module.exports = __webpack_public_path__ + "media/images/badge/campionato-vincente-aa908e65ffd1eda307db32086212fc92.png";